const api = {
  majorCompanies() {
    return `/customers/majorcompanies`;
  },
  getCustomersByType(type) {
    return `/customers/type/${type}`;
  },
  searchWithText(searchTerm) {
    return "/customers/search" + (searchTerm ? `?search=${searchTerm}` : "");
  },
  searchWithOptions() {
    return `/customers/search`;
  },
  getCustomerDetails(customerNumber) {
    return `/customers/${customerNumber}`;
  },
  updateCustomerDetails(customerNumber) {
    return `/customers/${customerNumber}`;
  },
  getNextAvailableAccountNumber() {
    return `/customers/nextaccountnumber`;
  },
  getAllSurveyTypes(customerNumber) {
    return `/customers/${customerNumber}/all-survey-types`;
  },
  getCustomerScorecardData() {
    return `/customers/score-card`;
  },
  getCustomerList() {
    return `/customers`;
  },
  getActiveSurveyTypes(accountNumber) {
    return `/customers/${accountNumber}/survey-types`;
  },
  getOrderSupplementOptions(accountNumber, surveyTypeId) {
    return `/customers/${accountNumber}/supplements/${surveyTypeId}`;
  },
  bulkOrder() {
    return `/customers/bulk-order-cases`;
  },
  getEnabledFeatures(accountNumber) {
    return `/customers/${accountNumber}/enabled-features`;
  },
  addCustomer(accountNumber) {
    return `/customers/${accountNumber}`;
  },
  getCaseInfo(controlIdNumber) {
    return `/customers/case-info/${controlIdNumber}`;
  },
  salesDetails(accountNumber) {
    return `/customers/${accountNumber}/sales`;
  },
  pdfExportSettingsByCustomer(accountNumber) {
    return `/pdfExportSettings/customer/${accountNumber}`;
  },
  pdfExportSettingsByCase(controlNumber) {
    return `/pdfExportSettings/case/${controlNumber}`;
  },
  pdfExportSettingsFields() {
    return `/pdfExportSettings/fields`;
  },    
};

export default api;
